import React, { useState, useEffect, useRef } from "react";
import { Fab, Box } from '@mui/material';
import { ViewProps } from "../../types/View";

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export type ScrollProps = {
  backgroundColor: string;
}

const ScrollControl = (props: ScrollProps & ViewProps) => {
  const [isTopVisible, setIsTopVisible] = useState(false);
  const [isBottomVisible, setIsBottomVisible] = useState(false);

  const scrollTopRef = useRef();
  const scrollBottomRef = useRef();
  const [refsSet, setRefsSet] = useState(false);

  useEffect(() => {
    if (scrollTopRef.current && scrollBottomRef.current) {
      setRefsSet(true);
    }
  }, [scrollTopRef.current, scrollBottomRef.current]);

  useEffect(() => {
    observe(scrollTopRef, setIsTopVisible);
  }, [scrollTopRef]);

  useEffect(() => {
    observe(scrollBottomRef, setIsBottomVisible);
  }, [scrollBottomRef]);

  const observe = (ref: React.MutableRefObject<any>, setVisibility: React.Dispatch<React.SetStateAction<boolean>>) => {
    let timeout: NodeJS.Timeout | null = null;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          setVisibility(entry.isIntersecting);
        }, 100);
      },
      {
        root: null, // Use the viewport as the root
        threshold: 0.1, // Trigger when 10% of the element is visible
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  };

  return <>
    <Box ref={scrollTopRef} />
      { props.children }
      <Box sx={{pb: 8}}></Box>
    <Box ref={scrollBottomRef} />    

    { refsSet && <Box className="text-center" sx={{
      position: "sticky",
      bottom: 0,
      pb: 2,
      height: "40px",
      width: "100%",
      background: `linear-gradient(transparent 0, var(--color-${props.backgroundColor}) 100%)`
    }}>
      { !isTopVisible && isBottomVisible && scrollTopRef.current && <Fab size="small" onClick={() => scrollTopRef.current.scrollIntoView({ behavior: "smooth" }) }><ArrowUpwardIcon fontSize="small" /></Fab> }
      { !isBottomVisible && scrollBottomRef.current && <Fab size="small" onClick={() => scrollBottomRef.current.scrollIntoView({ behavior: "smooth" }) }><ArrowDownwardIcon fontSize="small" /></Fab> }
    </Box> }
  </>;
}

export default ScrollControl;